/*
  set lowest price to each visible marker (airport) from all routes leading to it
*/
const setLowestPrices = (markers, routes) => {
  let lowestPrice = null
  for (let i = 0; i < markers.length; i++) {
    const matchedRoutes = []
    for (let j = 0; j < routes.length; j++) {
      if(routes[j].to === markers[i].iata)
        matchedRoutes.push(routes[j])
    }

    if(matchedRoutes.length > 0) {
      lowestPrice = matchedRoutes.reduce((prev, curr) => {
        if(prev.total < curr.total)
          return prev
        else
          return curr
      }, matchedRoutes[0].total)
    }

    markers[i].price = lowestPrice.total
  }

  return markers
}

export default setLowestPrices



// WEBPACK FOOTER //
// ./app/utils/setLowestPrices.js